import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6238f14a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"padding-bottom":"80px"} }
const _hoisted_2 = { class: "picList" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("返 回")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_ImgBox = _resolveComponent("ImgBox")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_PageMain = _resolveComponent("PageMain")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_FixedActionBar = _resolveComponent("FixedActionBar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.info)
      ? (_openBlock(), _createBlock(_component_PageMain, {
          key: 0,
          title: "意见反馈-查看"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              class: "addForm disabledFormShow",
              model: _ctx.info,
              "label-width": "auto",
              disabled: "",
              "label-position": "top"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "标题：",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.info.title,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.info.title) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "提交人名称：" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.info.name,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.info.name) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "提交人联系方式：" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.info.mobile,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.info.mobile) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "提交时间：" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.info.created_at,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.info.created_at) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "备注：" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.info.remark,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.info.remark) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "意见、反馈内容：",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.info.content,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.info.content) = $event)),
                      type: "textarea",
                      autosize: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                (_ctx.info.pic.length)
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      label: "图片：",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.info.pic, (item, index) => {
                            return (_openBlock(), _createBlock(_component_ImgBox, {
                              src: item,
                              width: 200,
                              height: 200,
                              key: index,
                              srcList: _ctx.info.pic
                            }, null, 8, ["src", "srcList"]))
                          }), 128))
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_FixedActionBar, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "danger",
          onClick: _ctx.onReturn
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    })
  ]))
}